import React from "react";
import { Container } from "react-bootstrap";
import { Skeleton, Box } from "@mui/material";

const BannerCarouselSkeleton = () => {
  return (
    <Container className="my-3">
      <Box>
        <Skeleton
          variant="rectangular"
          width="100%"
          height={350}
          animation="wave"
          sx={{
           
            bgcolor: "grey.300",
            "&::after": {
              background:
                "linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent)",
            },
          }}
        />
      </Box>
    </Container>
  );
};

export default BannerCarouselSkeleton;
